import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/reviews')({ staticData: { team: 'analytics' } });
